(function(){
  var t=document.getElementById('tTrack');
  var prev=document.getElementById('tPrev');
  var next=document.getElementById('tNext');
  if(!t) return;
  
  var dirMul=(document.documentElement.dir==='rtl')?-1:1;
  var cards=t.querySelectorAll('.t-card');
  if(!cards.length) return;
  
  function slideW(){
    return cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(t).gap||0);
  }

  if(prev) {
    prev.addEventListener('click', function(){
      t.scrollBy({left: -slideW() * dirMul, behavior: 'smooth'});
    });
  }
  if(next) {
    next.addEventListener('click', function(){
      t.scrollBy({left: slideW() * dirMul, behavior: 'smooth'});
    });
  }
})();
